if (!customElements.get('epg-pairs')) {
      customElements.define('epg-pairs', class extends HTMLElement {
        connectedCallback() {
          const inCart = (this.dataset.inCart || '').split(',');
          fetch(`${this.dataset.url}.json?product_id=${this.dataset.productId}&limit=8&intent=related`)
            .then((r) => r.json())
            .then(({ products }) => {
              const p = (products || []).find((x) => x.available && !inCart.includes(String(x.id)));
              if (!p) return;
              const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=200` : '';
              const price = (p.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
              const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
              this.innerHTML = `<p class="epg-pairs__title">Pairs well with</p>
                <a class="epg-pairs__card" href="${esc(p.url)}">
                  ${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" width="72" height="96" loading="lazy">` : ''}
                  <span class="epg-pairs__info"><span class="epg-pairs__name">${esc(p.title)}</span><span class="epg-pairs__price">${price}</span></span>
                  <span class="epg-pairs__cta">View</span>
                </a>`;
              this.hidden = false;
            })
            .catch(() => {});
        }
      });
    }
